module.exports = __webpack_public_path__ + "img/Login-window.512c06f6a5f390d46dd08b654e99137a.jpg";